import {COLORS_CONFIG, PLAYER_COLORS} from '../../configs/colors';

export function resolveFactionColor(colorKey, fallbackColor) {
  if (colorKey === PLAYER_COLORS.BROWN) return '#7b3c00';
  if (colorKey === PLAYER_COLORS.BLUE) return '#157be0';
  return COLORS_CONFIG[colorKey] || fallbackColor;
}
